import { QuizEvent, QuizEventName } from '../types/glossaryQuiz'

const QUIZ_EVENTS_KEY = 'ms_glossary_quiz_events'

export const trackQuizEvent = (name: QuizEventName, payload?: Record<string, unknown>): void => {
  const existing = getQuizEvents()
  const nextEvent: QuizEvent = {
    id: `quiz_event_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    name,
    payload,
    timestamp: new Date().toISOString()
  }
  localStorage.setItem(QUIZ_EVENTS_KEY, JSON.stringify([...existing, nextEvent]))
}

export const getQuizEvents = (): QuizEvent[] => {
  const rawEvents = localStorage.getItem(QUIZ_EVENTS_KEY)
  if (!rawEvents) {
    return []
  }

  try {
    return JSON.parse(rawEvents) as QuizEvent[]
  } catch {
    return []
  }
}
